import { Controller } from '@hotwired/stimulus';
import { AddressForm } from '../../form/components/address_form';

export default class extends Controller {
  static values = {
    mapApiKey: String,
    latitude: Number,
    longitude: Number,
    img: String,
    countryCodes: String,
  };

  connect() {
    const addressForm = new AddressForm(
      this.mapApiKeyValue,
      this.imgValue,
      this.latitudeValue,
      this.longitudeValue,
      this.countryCodesValue
    );

    setTimeout(function() {
      if ($('#address-full-input').isInViewport()) {
        addressForm.init();
      } else {
        // needs to be done on click as well as the map may not be shown at the load of the page
        // and will bug if not initialized
        $('.new-listing-address__radio').one('click', function() {
          addressForm.init();
        });
      }
    }, 250);
  }
}
